import axios from "axios";
export function deleteOrderLimits(accountId, id, type) {
  console.log("accountId: ", accountId)
  var config = {
    method: "delete",
    url: `${process.env.VUE_APP_APIHOST}/${type}/console/${accountId}/order-limits/${id}`
  };
  return axios(config);
}

export function deletePrinter(accountId, shop, data, type) {
  let config = {
      method: 'DELETE',
      url: `${process.env.VUE_APP_APIHOST}/${type}/console/${accountId}/printers/${data.printer.did}`,
      params: shop,
      data
  }
  return axios(config);
}

export function purgePrinterQueue(accountId, shop, data, type) {
  let config = {
    method: 'DELETE',
    url: `${process.env.VUE_APP_APIHOST}/${type}/console/${accountId}/printers/${data.printer.did}/purge-queue`,
    params: shop,
    data
  }
  return axios(config);
}

export function removeActiveVendor(accountId, vendor_code, type) {
  let config = {
    method: 'DELETE',
    url: `${process.env.VUE_APP_APIHOST}/${type}/console/${accountId}/mw-setting-active`,
    data: { vendor_code }
  }
  return axios(config);
}


export function removeSubscriber(accountId, type, subscribeType, data) {
  let config = {
    method: "DELETE",
    url: `${process.env.VUE_APP_APIHOST}/${type}/air3/${accountId}/types/${subscribeType}/unsubscribe`,
    data: data
  };
  return axios(config);
}